import React from 'react';

import MoreInformation from '@components/more-information';

const SiteDetailsMoreInfo = ({ moreInfoDataPointsMap }) => {
  return (
    <>
      <MoreInformation
        info={Object?.keys(moreInfoDataPointsMap)?.map((a) => {
          return {
            title: moreInfoDataPointsMap[a]?.value || null,
            heading: moreInfoDataPointsMap[a]?.title || null
          };
        })}
        hideEditBtn
      />
    </>
  );
};

export default SiteDetailsMoreInfo;
